import { BlueprintGrid } from "./Glyphs";
import styles from "./PageHero.module.css";

// Compact hero used by interior pages (About, Projects, Services,
// Contact). Title + eyebrow + optional subtitle, framed by a faint
// blueprint grid for the architectural feel. The home page uses its
// own bespoke hero in pages/Home.jsx.
export default function PageHero({ eyebrow, title, subtitle, code }) {
  return (
    <section className={styles.hero}>
      <BlueprintGrid color="#1a1d20" opacity={0.07} step={28} />
      <div className={styles.inner}>
        <div className={styles.meta}>
          {code && <span className={styles.code}>{code}</span>}
          {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
        </div>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </section>
  );
}
